import { scrollToSection } from "@/lib/scroll";

export const Emblem = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <circle cx="17" cy="28" r="9.5" stroke="#16233B" strokeWidth="3.4" />
    <circle cx="31" cy="28" r="9.5" stroke="#9DB8A8" strokeWidth="3.4" />
    <circle cx="17" cy="13" r="3.1" fill="#16233B" />
    <circle cx="31" cy="13" r="3.1" fill="#9DB8A8" />
    <path
      d="M24 7c-1.1-1.7-3.6-1.9-4.6-.2-.9 1.5-.3 3.4 4.6 5.9 4.9-2.5 5.5-4.4 4.6-5.9-1-1.7-3.5-1.5-4.6.2Z"
      fill="#C08A96"
    />
  </svg>
);

export const Wordmark = ({ dark = false, testId = "wordmark-link" }) => (
  <a
    href="#home"
    onClick={(e) => scrollToSection(e, "#home")}
    data-testid={testId}
    aria-label="Adeya Companions — home"
    className="flex items-center gap-3"
  >
    <Emblem />
    <span className="leading-none">
      <span
        className={`block font-serif text-lg font-semibold tracking-[0.22em] ${
          dark ? "text-cream" : "text-navy"
        }`}
      >
        ADEYA
      </span>
      <span className="mt-1 block font-sans text-[0.55rem] font-semibold tracking-[0.44em] text-mauve">
        COMPANIONS
      </span>
    </span>
  </a>
);
